import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  column-gap: 26px;
  padding: 15px 16px;
  border-radius: ${({ borderRadius }) => borderRadius}px;
  border: 0.71px solid ${({ theme }) => theme.border.black15};
  width: 100%;
  box-sizing: border-box;
  background: ${({ theme }) => theme.bg.card};
`;

export const TimeWrapper = styled.div`
  border-radius: 10px;
  background: ${({ bgClr }) => bgClr};
  display: grid;
  place-content: center;
  padding: 10px;
`;

export const InfoWrapper = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
`;

export const TitleText = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const Title = styled.div`
  color: ${({ theme }) => theme.text.title};
  font-size: 18.22px;
  font-weight: 600;
  line-height: 20.497px;
  position: relative;
  padding-top: ${({ hasText }) => (hasText ? "0px" : "10px")};
`;

export const Text = styled.div`
  color: ${({ theme }) => theme.text.text};
  font-size: 14px;
  font-weight: 500;
  line-height: 130%;
  position: relative;
`;

export const LabelArrow = styled.div`
  display: flex;
  align-items: center;
  column-gap: 8px;
  opacity: 0.4;
  align-self: flex-end;
  margin-left: 50px;
  padding-bottom: 10px;
`;

export const Label = styled.div`
  color: ${({ theme }) => theme.text.title};
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  white-space: nowrap;
`;
